import { DateFormatter, i18n } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import * as React from 'react';
import { connect } from 'react-redux';
import Rest from '../../webapi/Rest';
import DocumentiActions from './DocumentiActions';



class PreviewTab extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[Upload.jsx] ";
        this.state = {};
    }


    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        let columns = [
            { field: 'id', title: 'Id', sortable: 'true' },
            { field: 'dateUpd', title: 'Data ultima esecuzione', sortable: 'false', formatter: this.formatDate },
            { field: 'run', title: i18n('ARM_CORE_PRINT.SHARED.RUN', 'Restore'), formatter: this.columnRun },
            { field: 'elimina', title: i18n('ARM_CORE_PRINT.SHARED.ELIMINA', 'Elimina'), formatter: this.columnElimina },
        ];

        $(this.refs.ListPreviewTable).bootstrapTable({
            columns: columns,
            idField: "nomeDoc",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.detailsOnClick(row, $element, field),
            pagination: true,
        });
    }

    formatDate(value, row, index) {
        return DateFormatter.dataFormatter(value)
    }

    columnElimina(value, row, index) {
        console.log(this.componentName + " columnDetail: ");
        let temp;
        temp = "<button class='btn arm-gui-btn-danger btn-sm'><i class='fas fa-trash-alt fa-fw' data-toggle='tooltip' data-placement='top' title='Visualizza'/></button>";
        return temp;
    }
    columnRun() {
        console.log(this.componentName + " columnDetail: ");
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fa fa-arrow-down' data-toggle='tooltip' data-placement='top' title='Visualizza'/></button>";
        return temp;
    }

    // componentWillReceiveProps(nextProps) {
    //     console.log(this.componentName + ' componentWillReceiveProps');
    //     if (nextProps.nuovoDoc.listHistory !== this.props.nuovoDoc.listHistory) {
    //         console.log("\t rows: " + (nextProps.nuovoDoc.listHistory !== null ? nextProps.nuovoDoc.listHistory.length : "NULL"));
    //         $(this.refs.ListPreviewTable).bootstrapTable('load', nextProps.nuovoDoc.listHistory);
    //     }
    // }

    componentDidUpdate(prevProps) {
        if (prevProps.nuovoDoc.listHistory !== this.props.nuovoDoc.listHistory) {
            console.log("\t rows: " + (this.props.nuovoDoc.listHistory !== null ? this.props.nuovoDoc.listHistory.length : "NULL"));
            $(this.refs.ListPreviewTable).bootstrapTable('load', this.props.nuovoDoc.listHistory);
        }
    }

    detailsOnClick(row, $element, field) {
        if (field === "run") {
            this.props.getHistory(row);
        }

        if (field === "elimina") {
            this.props.deleteHistory(row);
        }
    }


    render() {
        const { nuovoDoc, handleChangeDoc, isAlreadyExistingDoc, isInEditMode } = this.props;
        const baseUrl = Rest.restBaseurl;

        return (

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', margin: '2rem 0rem' }}>
                <div style={{ width: '100%', border: '1px solid #e4e4e4', boxShadow: '0 1px 5px 0 rgb(0 0 0 / 10%), 0 2px 2px 0 rgb(0 0 0 / 2%)', padding: '1rem' }}>
                    <span>{i18n("ARM_CORE_PRINT.SHARED.TABELLA_HISTORY", 'Tabella di history')}</span>
                    <table ref="ListPreviewTable" />
                </div>

                <br />
                <div style={{ width: '100%', border: '1px solid #e4e4e4', boxShadow: '0 1px 5px 0 rgb(0 0 0 / 10%), 0 2px 2px 0 rgb(0 0 0 / 2%)', padding: '1rem' }}>

                    <span>{i18n("ARM_CORE_PRINT.SHARED.PARAMETRI", 'Valorizza i parametri per effettuare la stampa')}</span>
                    <div className='row' style={{ marginTop: '1.5rem' }}>

                        {nuovoDoc.listParameters && nuovoDoc.listParameters.length > 0 ?
                            nuovoDoc.listParameters.map((parameter, indexParam) =>
                                <div className='col-6' key={"param" + indexParam}>
                                    <agui.CoolTextInput
                                        id="value"
                                        className="col-6"
                                        onChange={(value) => this.props.handleChangeParameter(parameter, value)}
                                        value={this.props.parametersMap ? this.props.parametersMap.get(parameter) : null}
                                        label={parameter}
                                    />
                                </div>
                            )
                            :
                            <span className='ml-4'>{i18n("ARM_CORE_PRINT.SHARED.PARAMETRI", 'Nessun parametro presento per questa data source')}</span>
                        }
                    </div>
                </div>
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        handleChangeParameter(key, value) {
            return dispatch(DocumentiActions.handleChangeParameter(key, value))
        },
        getHistory(row) {
            return dispatch(DocumentiActions.getHistory(row))
        },
        deleteHistory(row) {
            return dispatch(DocumentiActions.deleteHistory(row))
        }
    }

};

function mapStateToProps(state) {
    return {
        nuovoDoc: state.documentiReducer.nuovoDoc,
        parametersMap: state.documentiReducer.parametersMap,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewTab);
